// extracted by mini-css-extract-plugin
module.exports = {"results":"Results-module--results--e3b89d","clickable":"Results-module--clickable--4f8782"};